export enum AuthProviderId {
  Password = 'password',
  Google = 'google.com',
  Apple = 'apple.com',
  Facebook = 'facebook.com'
}
